/*
* PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
* Copyright © 2026 Pearson Education, Inc.
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Pearson Education, Inc. The intellectual and technical concepts contained
* herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
* patent applications, and are protected by trade secret or copyright law.
* Dissemination of this information, reproduction of this material, and copying or distribution of this software
* is strictly forbidden unless prior written permission is obtained
* from Pearson Education, Inc.
*/

/**
 * Root OpenFeature React provider (required for useOpenFeatureClient in children).
 *
 * @file AppOpenFeatureWrapper.jsx
 * @author Mohamed yasar arabath M
 */

import React from 'react';
import PropTypes from 'prop-types';
import { OpenFeatureProvider } from '@openfeature/react-sdk';


export default function AppOpenFeatureWrapper({ children }) {
  return <OpenFeatureProvider>{children}</OpenFeatureProvider>;
}

AppOpenFeatureWrapper.propTypes = {
  children: PropTypes.node.isRequired
};
